"use strict";

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMetric = exports.reportMetrics = exports.createSemanticMetrics = exports.asNanoseconds = exports.MetricTypes = void 0;

var isomorphic_logger_1 = __importDefault(require("@spotify-internal/isomorphic-logger"));

exports.MetricTypes = {
  COUNTER: 'counter',
  GAUGE: 'gauge',
  TIMER: 'timer'
};

function asNanoseconds(n) {
  return n;
}

exports.asNanoseconds = asNanoseconds;

var reportMetrics = function reportMetrics(metrics, config) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var reporterPromises;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(config.reporter)) {
              _context.next = 6;
              break;
            }

            reporterPromises = config.reporter.map(function (reporter) {
              return reporter.send(metrics);
            });
            _context.next = 4;
            return Promise.all(reporterPromises);

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.next = 8;
            return config.reporter.send(metrics);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.reportMetrics = reportMetrics;

var createSemanticMetrics = function createSemanticMetrics(config) {
  var Batching = {
    queue: [],
    timeout: undefined,
    flush: function flush() {
      reportMetrics(this.queue, config);
      this.queue = [];
      this.timeout = undefined;
    }
  };
  var isWindowUnloading = false;

  if (typeof config.batching === 'undefined') {
    config.batching = {
      delay: 4000
    };
  }

  if (config.batching && typeof window === 'object' && typeof window.addEventListener === 'function') {
    window.addEventListener('beforeunload', function () {
      isWindowUnloading = true;
      Batching.flush();
    });
  }

  var sendMetric = function sendMetric(metric) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _a, _b, clonedMetric;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof config.dev !== 'undefined' ? config.dev : process && (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development'))) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              clonedMetric = Object.assign({}, metric);

              if (metric.tags) {
                clonedMetric.tags = Object.assign({}, metric.tags);
              }

              clonedMetric.key = clonedMetric.key || config.key;

              if (clonedMetric.key) {
                _context2.next = 7;
                break;
              }

              throw new Error("metric.key is required. Got: \"".concat(clonedMetric.key, "\". Set it in createSemanticMetrics(...) or pass it to sendMetric(...)."));

            case 7:
              clonedMetric.tags = Object.assign({
                app: (_a = config.app) !== null && _a !== void 0 ? _a : clonedMetric.key,
                application: (_b = config.app) !== null && _b !== void 0 ? _b : clonedMetric.key
              }, clonedMetric.tags);

              if (config.component_id) {
                clonedMetric.component_id = clonedMetric.component_id || config.component_id;
              } else {
                clonedMetric.component_id = config.key;
              }

              if (!(config.batching && !isWindowUnloading)) {
                _context2.next = 14;
                break;
              }

              Batching.queue.push(clonedMetric);

              if (!Batching.timeout) {
                Batching.timeout = setTimeout(function () {
                  return Batching.flush();
                }, config.batching.delay);
              }

              _context2.next = 16;
              break;

            case 14:
              _context2.next = 16;
              return reportMetrics([clonedMetric], config);

            case 16:
              return _context2.abrupt("return");

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  return {
    sendMetric: sendMetric,
    config: config,
    isWindowUnloading: isWindowUnloading
  };
};

exports.createSemanticMetrics = createSemanticMetrics;

var SemanticMetricsSingleton =
/*#__PURE__*/
function () {
  function SemanticMetricsSingleton() {
    _classCallCheck(this, SemanticMetricsSingleton);
  }

  _createClass(SemanticMetricsSingleton, null, [{
    key: "init",
    value: function init(config) {
      if (SemanticMetricsSingleton.config) {
        isomorphic_logger_1.default.error('SemanticMetrics has already been initialized. This may lead to dangerous side effects such as your metrics disappearing from Grafana due to the `key` value being overwritten by something else');
      }

      isomorphic_logger_1.default.warn('The singleton usage of SemanticMetrics will be deprecated. Please use createSemanticMetrics()');
      SemanticMetricsSingleton.config = config;

      var _createSemanticMetric = createSemanticMetrics(config),
          sendMetric = _createSemanticMetric.sendMetric,
          isWindowUnloading = _createSemanticMetric.isWindowUnloading;

      SemanticMetricsSingleton.sendMetric = sendMetric;
      SemanticMetricsSingleton.isWindowUnloading = isWindowUnloading;
    }
  }]);

  return SemanticMetricsSingleton;
}();

exports.default = SemanticMetricsSingleton;

var sendMetricSingleton = function sendMetricSingleton(metric) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (SemanticMetricsSingleton.config) {
              _context3.next = 2;
              break;
            }

            throw new Error('SemanticMetrics has not been initialized. Call SemanticMetrics.init()');

          case 2:
            return _context3.abrupt("return", SemanticMetricsSingleton.sendMetric(metric));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.sendMetric = sendMetricSingleton;